/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_No_ChildrenInputs */



/**
* | output |
* | --- |
* | "No child leagues yet." |
*
* @param {League_No_ChildrenInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_no_children = /** @type {((inputs?: League_No_ChildrenInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_No_ChildrenInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune ligue enfant pour l'instant.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no hay ligas hijas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma liga filha ainda.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun campionato figlio ancora.")
	return /** @type {LocalizedString} */ ("No child leagues yet.")
});